<input #field
  type="hidden"
  [ngModel]="innerValue"
  (ngModelChange)="writeValue($event)">
<div class="input-group">
  @if (!isLinked) {
    <input type="text"
      class="form-control"
      [(ngModel)]="innerValue"
      [disabled]="isLinked"
      (ngModelChange)="writeValue($event)"
      [required]="required">
  }
  @if (innerValue && isLinked) {
    <input
      type="text"
      class="form-control"
      [ngModel]="selected?.number"
      disabled
      [required]="required">
  }
  <div class="input-group-append">
    @if (isLinked) {
      <button
        type="button"
        class="clear-search"
        (click)="clear()">
        <i class="fas fa-times-circle"></i>
      </button>
    }
    @if (!isLinked) {
      <button
        class="btn btn-action"
        (click)="search()"
        type="button"
        [disabled]="!innerValue">
        <reporter-icon icon="Search"></reporter-icon>
      </button>
    }
  </div>
  <div class="dropdown-menu w-100 scrollable"
    [class.show]="products?.length > 1 && !isLinked">
    @for (product of products; track product; let index = $index) {
      <button
        class="dropdown-item"
        type="button"
        (click)="select(product)">{{ product.number }}
      </button>
    }
  </div>
  @if (products?.length === 0 || showError) {
    <div class="w-100 alert alert-warning">
      Product Not Found!
    </div>
  }
</div>

